<template>
  <div>
    <div id="custom-hight-risk-upload">
      <div class="columns">
        <div
          v-if="data.topic === 'orgCompanyName'"
          class="column"
        >
          <b-field
            id="company-name"
          >
            <b-input
              v-validate="'required'"
              v-model="form.orgCompanyName"
              :placeholder="$t('kyc.company_placholder')"
              name="company name"
              expanded
              data-test="edit-kyc-org-information--company-name-field"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('company name') }}</span>
        </div>
      </div>
      <div class="columns">
        <div
          v-if="data.topic === 'orgTaxId'"
          class="column"
        >
          <b-field
            id="tax-id"
          >
            <b-input
              v-validate="'required'"
              v-model="form.orgTaxId"
              :placeholder="$t('kyc.tax_id')"
              name="tax id"
              expanded
              data-test="edit-kyc-org-information--org-tax-id-field"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('tax id') }}</span>
        </div>
      </div>
      <div class="columns">
        <div
          v-if="data.topic === 'orgCompanyAddressLineOne'"
          class="column"
        >
          <b-field id="company-address">
            <b-input
              v-validate="'required'"
              v-model="form.orgCompanyAddressLineOne"
              :placeholder="$t('kyc.company_address')"
              name="company address"
              expanded
              data-test="edit-kyc-org-information--company-address-field"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('company address') }}</span>
        </div>
      </div>
      <div class="columns">
        <div
          v-if="data.topic === 'orgCompanyAddressLineTwo'"
          class="column"
        >
          <b-field>
            <b-input
              v-model="form.orgCompanyAddressLineTwo"
              :placeholder="$t('kyc.company_address_line_2')"
              expanded
              data-test="edit-kyc-org-information--company-address-line-2-field"
            />
          </b-field>
        </div>
      </div>
      <div class="columns">
        <div
          v-if="data.topic === 'orgCountry'"
          class="column"
        >
          <b-field
            id="organize country"
            class="kyc-information-is-expanded"
          >
            <b-select
              v-validate="'required'"
              v-model="form.orgCountry"
              :placeholder="$t('kyc.company_country')"
              name="organize country"
              data-test="edit-kyc-org-information--org-country-field"
            >
              <option
                v-for="(country, index) in countries"
                :value="country.en_short_name"
                :key="index"
                :disabled="country.disabled"
              >
                {{ country.en_short_name }}
              </option>
            </b-select>
          </b-field>
          <span class="is-invalid">{{ errors.first('organize country') }}</span>
        </div>
      </div>
      <div class="columns dp-flex">
        <div
          v-if="data.topic === 'orgCompanyProvince'"
          class="column"
        >
          <b-field id="company-province">
            <b-select
              v-validate="'required'"
              v-if="form.orgCountry ? form.orgCountry === 'Thailand' : orgCountry === 'Thailand'"
              v-model="form.orgCompanyProvince"
              :placeholder="$t('kyc.company_province')"
              name="company province"
              expanded
              data-test="edit-kyc-org-information--company-province-field"
            >
              <option
                v-for="province in provincesInThailand"
                :value="province.key"
                :key="province.key"
              >
                {{ province.th }}
              </option>
            </b-select>
            <b-input
              v-validate="'required'"
              v-else
              v-model="form.orgCompanyProvince"
              :placeholder="$t('kyc.company_province')"
              name="company province"
              expanded
              data-test="edit-kyc-org-information--company-province-field"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('company province') }}</span>
        </div>
      </div>
      <div class="columns dp-flex">
        <div
          v-if="data.topic === 'orgCompanyCity'"
          class="column"
        >
          <b-field id="company-city">
            <b-input
              v-validate="'required'"
              v-model="form.orgCompanyCity"
              :placeholder="$t('kyc.company_city')"
              name="company city"
              expanded
              data-test="edit-kyc-org-information--company-city-field"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('company city') }}</span>
        </div>
      </div>
      <div class="columns dp-flex">
        <div
          v-if="data.topic === 'orgCompanyPostcode'"
          class="column"
        >
          <b-field id="company-postcode">
            <b-input
              v-validate="'required|numeric|length:5'"
              v-model="form.orgCompanyPostcode"
              :placeholder="$t('kyc.company_zipcode')"
              name="company postcode"
              expanded
              data-test="edit-kyc-org-information--company-postcode-field"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('company postcode') }}</span>
        </div>
      </div>
      <div class="columns dp-flex">
        <div
          v-if="data.topic === 'orgTel'"
          class="column"
        >
          <b-field id="company-tel-number">
            <b-input
              v-validate="'required'"
              v-model="form.orgTel"
              :placeholder="$t('kyc.company_tel_placeholder')"
              name="company phone number"
              expanded
              data-test="edit-kyc-org-information--company-phone-number-field"
            />
          </b-field>
          <span class="is-invalid">{{ errors.first('company phone number') }}</span>
        </div>
      </div>
      <div class="columns">
        <div
          v-if="data.topic === 'orgBusinessType'"
          class="column"
        >
          <b-field
            id="business-Type"
            class="kyc-information-is-expanded"
          >
            <b-select
              v-validate="'required'"
              v-model="form.orgBusinessType"
              :placeholder="$t('kyc.business_type')"
              name="business type"
              data-test="edit-kyc-org-information--business-type-field"
            >
              <option
                v-for="business in sortBusinessList"
                :value="business.key"
                :key="business.key"
                name="business type"
              >
                {{ business[$i18n.locale] }}
              </option>
            </b-select>
          </b-field>
          <span class="is-invalid">{{ errors.first('business type') }}</span>
        </div>
      </div>
      <div class="columns">
        <!-- The average income -->
        <div
          v-if="data.topic === 'averageIncome'"
          class="column"
        >
          <b-field
            id="average-income"
            class="kyc-information-is-expanded"
          >
            <b-select
              v-validate="'required'"
              v-model="form.averageIncome"
              :placeholder="$t('kyc.avg_income')"
              name="average income"
              data-test="edit-kyc-upload-doc-hight-risk--average-income-field"
            >
              <option
                v-for="income in averageIncomeList"
                :value="income.key"
                :key="income.key"
                name="income"
              >
                {{ income[$i18n.locale] }}
              </option>
            </b-select>
          </b-field>
          <span class="is-invalid">{{ errors.first('average income') }}</span>
        </div>
      </div>
      <div class="columns">
        <!-- Proof of income -->
        <div
          v-if="data.topic === 'proofOfIncome'"
          class="column document-box"
        >
          <div class="example-img">
            <b-upload
              v-validate="'required'"
              v-model="form.proofOfIncome"
              name="proof income"
              accept="image/*,.pdf"
              drag-drop
              @input="(file) => onUploadDoc(file, 'proofOfIncome')"
            >
              <section
                class="section"
                data-test="edit-kyc-upload-doc-hight-risk--proof-income"
              >
                <div class="content has-text-centered">
                  <img
                    src="/static/img/icon-company-cer-doc.png"
                    class="dropzone-img--certificate"
                  >
                </div>
                <div class="browse-btn">
                  {{ $t('kyc.browse_file') }}
                </div>
              </section>
            </b-upload>
            <span class="is-invalid">{{ errors.first('proof income') }}</span>
            <b-tag
              v-if="form.proofOfIncome"
              type="is-primary"
            >
              {{ form.proofOfIncome.name }}
            </b-tag>
            <div
              v-if="proofOfIncomeOverSize"
              class="is-invalid t-al-center"
            >
              {{ $t('kyc.doc_limit') }} {{ limitFileSizeInMb }} MB
            </div>
          </div>
        </div>
      </div>
      <div class="columns">
        <!-- Evidence of asset ownership -->
        <div
          v-if="data.topic === 'assetOwnership'"
          class="column document-box"
        >
          <div class="example-img">
            <b-upload
              v-validate="'required'"
              v-model="form.assetOwnership"
              name="asset ownership"
              accept="image/*,.pdf"
              drag-drop
              @input="(file) => onUploadDoc(file, 'assetOwnership')"
            >
              <section
                class="section"
                data-test="edit-kyc-upload-doc-hight-risk--asset-ownership"
              >
                <div class="content has-text-centered">
                  <img
                    src="/static/img/icon-company-cer-doc.png"
                    class="dropzone-img--certificate"
                  >
                </div>
                <div class="browse-btn">{{ $t('kyc.browse_file') }}</div>
              </section>
            </b-upload>
            <span class="is-invalid">{{ errors.first('asset ownership') }}</span>
            <b-tag
              v-if="form.assetOwnership"
              type="is-primary"
            >
              {{ form.assetOwnership.name }}
            </b-tag>
            <div
              v-if="assetOwnershipOverSize"
              class="is-invalid t-al-center"
            >
              {{ $t('kyc.doc_limit') }} {{ limitFileSizeInMb }} MB
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { KYC_DOC_FILE_SIZE_LIMIT_IN_MB } from '@/constants'
import { sortDataByLanguage } from '@/utils/helper'

export default {
  name: 'OrgInformation',
  inject: ['$validator'],
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    data: {
      type: Object,
      default: () => {}
    },
    orgCountry: {
      type: String,
      required: true
    },
    countries: {
      type: Array,
      default: () => []
    },
    provincesInThailand: {
      type: Array,
      default: () => []
    },
    businessList: {
      type: Array,
      default: () => []
    },
    averageIncomeList: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      proofOfIncomeOverSize: false,
      assetOwnershipOverSize: false,
      limitFileSizeInMb: KYC_DOC_FILE_SIZE_LIMIT_IN_MB
    }
  },
  computed: {
    sortBusinessList () {
      return sortDataByLanguage(this.businessList, this.$i18n.locale)
    },
    computedForm: function () {
      return Object.assign({}, this.form)
    }
  },
  watch: {
    computedForm: {
      handler: function (newVal, oldVal) {
        if (newVal.orgCountry !== oldVal.orgCountry) {
          delete this.form.orgCompanyProvince
        }
      },
      deep: true
    }
  },
  methods: {
    async onUploadDoc (file, key) {
      this[`${key}OverSize`] = false
      if ((file.size / 1000000) > this.limitFileSizeInMb) {
        this[`${key}OverSize`] = true
        this.form[key] = null
      }
    }
  }
}
</script>

<style lang="scss">
.kyc-information-is-expanded {
  .control {
    .select {
      width: 100%;
      select {
        width: 100%;
      }
    }
  }
}
#custom-hight-risk-upload {
  .upload .upload-draggable {
    width: 470px;
  }
  .tag {
    margin-top: 10px;
    span {
      font-size: 14px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
@media only screen and (max-width: 768px) {
  #custom-hight-risk-upload {
    .upload .upload-draggable {
      width: 100%;
    }
    .tag {
      width: 100%;
    }
  }
}
</style>

<style lang="scss" scoped>
.document-box {
  width: 100%;
  max-width: 70%;
  margin: 0 auto;
}
.example-img {
  text-align: center;
  margin: 20px 0 80px;
}
.dropzone-img {
  &--certificate {
    max-width: 173px;
    width: 100%;
  }
  &--shareholders {
    max-width: 420px;
    width: 100%;
  }
  &--attorney {
    max-width: 236px;
    width: 100%;
  }
}
.browse-btn {
  border-radius: 3px;
  background-color: #069bf9;
  max-width: 250px;
  padding: 13px;
  color: #fff;
  font-size: 15px;
  font-weight: bold;
  letter-spacing: 0.37px;
  margin: 0 auto;
  text-align: center;
  cursor: pointer;
  margin-top: 20px;
}
.t-al-center {
  text-align: center;
}
@media only screen and (max-width: 768px) {
  .example-img {
    text-align: center;
    margin: 20px 0 30px;
  }
  .document-box {
    max-width: 95%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/SummaryOfKYC/components/OrgInformation.vue